import type { RetailOrg } from '@jane/business-admin/types';
import { AuthStorage } from '@jane/shared/auth';

export function setRetailOrg(selected_org: RetailOrg) {
  AuthStorage.set('retail-org', JSON.stringify(selected_org));
}

export function getRetailOrg() {
  const retailOrg = AuthStorage.get<string>('retail-org');

  return JSON.parse(retailOrg || '{}');
}

export function removeRetailOrg() {
  AuthStorage.remove('retail-org');
}
